(ns kyber.components.composite.resource-icon-preview
  (:require [kyber.components.base.icons :as icon]
            [kyber.styles.core :refer [gs styles->classes]]))

(def classes
  (styles->classes
   {:resource-icon
    {:color (str (gs [:colors :primary-lite-700]))
     :margin-right (gs [:spacing :p12])}}))

(defn- render-icon-preview
  [icon-name small class]
  [(if (true? small)
     icon/icon-lg
     icon/icon-xl)
   (cond->
    {:class [(:resource-icon classes)]}
     class
     (update :class #(if (string? class)
                       (conj % class)
                       (into % class)))) icon-name])

(defn render
  ([resource] [render resource {:small false}])
  ([resource {:keys [small class]}]
   (let [file-type (or (:resource/file-type resource)
                       (:file-type resource))]
     [:<>
      (case (keyword file-type)
        :pdf [render-icon-preview :file-alt small class]
        :image [render-icon-preview :file-image small class]
        :audio [render-icon-preview :file-audio small class]
        :video [render-icon-preview :file-video small class]
        :application [render-icon-preview :file-alt small class]
        [render-icon-preview :download small class])])))
